import { Box, Button, Grid, Typography } from "@mui/material";
import Sidebar from "../../components/sidebar/sidebar";
import { Routes, Route, useNavigate, Outlet } from "react-router-dom";
import PigmyCollectionTable from "../../components/pigmyCollectionComponent.js/pigmyCollcetionTable";

function PigmyCollections() {
  const navigate = useNavigate();
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, pt: 3, pr: 2 }}>
          <Box height={65} />
          <Box>
            <Typography variant="h4">Pigmy Collections</Typography>
          </Box>

          <Box mt={1}>
            <Routes>
              <Route path="/" element={<PigmyCollectionTable />} />
            </Routes>
          </Box>
        </Box>
      </Box>
      {/* Outlet is used for rendering nested routes if further nesting is needed */}
      <Outlet />
    </div>
  );
}

export default PigmyCollections;
